export default __webpack_public_path__ + "static/media/playstore.8e5ea860.png";